import { AsModuleHelper, AsStoreModule } from '@/types/vuex/helpers';
import { createNamespacedHelpers, ActionContext, MutationTree } from 'vuex';
import { IRootState } from '@/store/rootstate';
import { CompanySearchItem } from '@/api/signup/interface';

interface IState {}

interface IGetters {}

/* Actions */
interface IActions {
  company(companyNumber: string): Promise<CompanySearchItem>;
}
interface IStoreActions<S, R> {
  company(injectee: ActionContext<S, R>, companyNumber: string): Promise<CompanySearchItem>;
}
/* /Actions */

export enum Mutations {}

type MutationType<S, E, K = keyof keyof E> = { [k in keyof K]: MutationTree<S> };

export type module = AsStoreModule<
  IState,
  IGetters,
  IStoreActions<IState, IRootState>,
  MutationType<IState, Mutations>
>;
export default createNamespacedHelpers('lookup') as AsModuleHelper<IState, IGetters, IActions>;
